'use client';
import { createContext, useContext } from 'react';

// Default context shape with no-op functions
export const UserContext = createContext({
  user: null,
  error: null,
  ember: false,
  mutate: async () => null,
  clearUserContext: async () => null,
});

export const useUser = () => useContext(UserContext);